import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../modules/infra/i18n';
import LockableInput from '../../../../common/LockableInput';
import Input from '../../../../common/input';
import OptionInput from '../../../../common/optionInput';
import Switch from '../../../../common/checkboxSwitch';
import Tooltip from '../../../../common/tooltip';
import * as shapes from '../shapes';
import Footer from '../containers/Footer';
import { BRAND_ACCESS_MESSAGE } from '../../../../common/constants';

const FormTaxDetails = ({ handleSubmit, submitting, baseUrl, isShop, edit, onDelete }) => {
  const isLimitedEditAccess = isShop && edit;

  const limitedAccessTooltip = (
    <div className="u-position-relative" display-if={isLimitedEditAccess}>
      <div className="c-protected-trigger">
        <span className="c-protected-input-popup">{t('settings:taxes.form_details.brand_manager_login')}</span>
      </div>
    </div>
  );

  return (
    <div className="c-inner-wrapper u-pt u-br-12">
      <h2 className="c-heading c-heading--dark u-mb">{t('settings:taxes.form_details.title')}</h2>
      <div className="c-separator u-mv" />
      <form onSubmit={handleSubmit}>
        <fieldset disabled={submitting}>
          <div className="u-ph">
            <div className="layout">
              <div className="layout__item o-flexbox o-flexbox--justify-start o-flexbox--content-align-center">
                <Switch name="enabled" label={t('settings:taxes.form_details.enabled_label')} wrapperClass="u--mr--" />
                <Tooltip className="c-info-tooltip-new--form">
                  <div className="u-m--">{t('settings:taxes.form_details.disabled_tooltip')}</div>
                </Tooltip>
              </div>
              <div
                className="layout__item o-flexbox o-flexbox--justify-start
                  o-flexbox--content-align-center c-protected-input"
              >
                <Switch
                  name="externalOrdersOnly"
                  label={t('settings:taxes.form_details.external_orders_only_label')}
                  disabled={isLimitedEditAccess}
                  wrapperClass="u--mr--"
                />
                <Tooltip display-if={!isLimitedEditAccess} className="c-info-tooltip-new--form">
                  <div className="u-m--">{t('settings:taxes.form_details.external_orders_tooltip')}</div>
                </Tooltip>
                {limitedAccessTooltip}
              </div>
              <div className="layout__item c-protected-input">
                <span className="c-label-new">{t('settings:taxes.form_details.tax_name_label')}</span>
                <LockableInput
                  className="c-input"
                  name="name"
                  type="text"
                  placeholder={t('settings:taxes.form_details.tax_name_placeholder')}
                  disabled={isLimitedEditAccess}
                  hint={BRAND_ACCESS_MESSAGE}
                />
              </div>
              <div className="layout__item">
                <span className="c-label-new">{t('settings:taxes.form_details.percentage_label')}</span>
                <Input
                  className="c-input"
                  name="percentage"
                  type="number"
                  step="0.001"
                  prefix="%"
                  placeholder={t('settings:taxes.form_details.percentage_placeholder')}
                />
              </div>
              <div className="layout__item">
                <div className="layout layout--small layout--auto o-flexbox o-flexbox--justify-start">
                  <div
                    className="layout__item o-flexbox o-flexbox--justify-start
                      o-flexbox--content-align-center c-protected-input"
                  >
                    <OptionInput name="addToPrice" parse={(val) => val === 'true'} value disabled={isLimitedEditAccess}>
                      {t('settings:taxes.form_details.add_to_price')}
                    </OptionInput>
                    {limitedAccessTooltip}
                  </div>
                  <div
                    className="layout__item o-flexbox o-flexbox--justify-start
                      o-flexbox--content-align-center c-protected-input"
                  >
                    <OptionInput
                      name="addToPrice"
                      parse={(val) => val === 'true'}
                      value={false}
                      disabled={isLimitedEditAccess}
                    >
                      {t('settings:taxes.form_details.include_in_price')}
                    </OptionInput>
                    {limitedAccessTooltip}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer baseUrl={baseUrl} onDelete={onDelete} />
        </fieldset>
      </form>
    </div>
  );
};

FormTaxDetails.propTypes = {
  handleSubmit: shapes.handler,
  submitting: shapes.submitting,
  baseUrl: shapes.url,
  edit: PropTypes.bool,
  isShop: PropTypes.bool,
  onDelete: PropTypes.func,
};

FormTaxDetails.defaultProps = {
  handleSubmit: () => null,
  submitting: false,
  baseUrl: '/settings/taxes',
  edit: false,
  isShop: false,
  onDelete: null,
};

export default FormTaxDetails;
